import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  h1: () => i18n.t(i18nKeys.submitMailingAddress__h1__v2),
  instructionsOne: () => i18n.t(i18nKeys.submitMailingAddress__instructionsOne),
  instructionsTwo: () => i18n.t(i18nKeys.submitMailingAddress__instructionsTwo),
  streetAddress: () => i18n.t(i18nKeys.common__streetAddress),
  streetAddressTwo: () => i18n.t(i18nKeys.common__streetAddressTwo),
  city: () => i18n.t(i18nKeys.common__city),
  state: () => i18n.t(i18nKeys.common__state),
  province: () => i18n.t(i18nKeys.common__province),
  selectState: () => i18n.t(i18nKeys.common__selectState),
  selectProvince: () => i18n.t(i18nKeys.common__selectProvince),
  zipcode: () => i18n.t(i18nKeys.common__zipcode),
  submitButton: () => i18n.t(i18nKeys.submitMailingAddress__submitButton),
  back: () => i18n.t(i18nKeys.common__back),
}
